import { AddressZero } from '@ethersproject/constants'
import { ChainId } from '@sushiswap/chain'
import { Native } from '@sushiswap/currency'
import { FURO_SUBGRAPH_URL } from '@sushiswap/graph-config'
import { useQuery } from '@tanstack/react-query'

import { getBuiltGraphSDK } from '../../.graphclient'
import { isSupportedChainId } from '../../config'
import { fetchWithTimeout } from './fetchWithTimeout'

interface UseRebaseDTO {
  chainId: ChainId
  address: string | undefined
  enabled?: boolean
}

export const queryRebaseDTO = async ({ chainId, address }: Omit<UseRebaseDTO, 'enabled'>) => {
  if (!address || !isSupportedChainId(chainId)) return null

  const sdk = getBuiltGraphSDK({
    chainId,
    url: FURO_SUBGRAPH_URL[chainId]
  })

  const data = await fetchWithTimeout(() => sdk.bentoBoxRebase({
    id: address === AddressZero ? Native.onChain(chainId).wrapped.address.toLowerCase() : address,
  }))

  return data?.rebase ?? null
}

export const useRebaseDTO = ({ chainId, address, enabled = true }: UseRebaseDTO) => {
  return useQuery({
    queryKey: ['useRebaseDTO', { chainId, address }],
    queryFn: async () => await queryRebaseDTO({ chainId, address }),
    enabled: Boolean(enabled && address),
  })
}
